/* Singleton class for firebase config */

import * as firebase from 'firebase';

const config = {
    apiKey: "AIzaSyC_qGRQxxiImXJ8xhTytI36TrtQ3_RPe8A",
    authDomain: "chatpool-3df2a.firebaseapp.com",
    databaseURL: "https://chatpool-3df2a.firebaseio.com",
    projectId: "chatpool-3df2a",
    storageBucket: "chatpool-3df2a.appspot.com",
    messagingSenderId: "1086993776851"
};
firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js